/** @jsxImportSource @emotion/react */

import { Global, css } from '@emotion/react'
import { Fragment, ReactElement } from 'react';
import tokubaipriceBoldItalicttf from './tokubaiprice-BoldItalic.ttf'
import tokubaipriceBoldItalicwoff from './tokubaiprice-BoldItalic.woff'

export default function TokubaiPriceFontFace(): ReactElement {
  return (
    <Fragment>
      <Global
        styles={css`
          @font-face {
            font-family: tokubaipricebolditalic;
            src: url('${tokubaipriceBoldItalicwoff}') format('woff'),
              url('${tokubaipriceBoldItalicttf}') format('truetype');
            font-weight: normal;
            font-style: normal;
          }
        `}
      />
    </Fragment>
  )
}

export const tokubaiprice = css`
  font-family: tokubaipricebolditalic;
`
